import { GetStaticProps, InferGetStaticPropsType } from "next";
import { ParsedUrlQuery } from "querystring";

import { GOI_WEB_URL, NextLink, Spacing, call, customEvent } from "goi_common";

import DefaultPageLayout from "@/components/DefaultPageLayout";
import NonBorderTable from "@/components/table/NonBorderTable";
import OutlinedButton from "@/components/button/OutlinedButton";

import ParlorClosedGuideInformation from "@/containers/ParlorClosedContainer/components/ParlorClosedGuideInformation";
import { ClosedSangjoMenuTabs } from "@/containers/ParlorClosedContainer/components/ClosedSangjoMenuTabs";

import CLOSED_SANGJO_LIST from "@/constants/closed_sangjo.json";

interface Params extends ParsedUrlQuery {
  id: string;
}

export const getStaticPaths = async () => {
  const paths = CLOSED_SANGJO_LIST.map((closedSangjo) => {
    return {
      params: {
        id: String(closedSangjo.id),
      },
    };
  });

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const { id } = params as Params;

  const closedSangjoData = CLOSED_SANGJO_LIST.find(
    (closedSangjo) => closedSangjo.id === Number(id),
  );

  const companyName = closedSangjoData?.companyname || "";

  const title = `${companyName} 폐업 상조 피해 보상 받기 - [상조 상품 비교 사이트, 헤이상조]`;
  const description = `${companyName} 폐업 상조 피해 보상 받을 수 있는 방법을 안내해드립니다. 자세한 내용은 피해 보상 가이드북을 통해 확인하세요.`;
  const keywords = `${companyName}, ${companyName} 상조 폐업, ${companyName} 폐업, ${companyName} 피해 보상, ${companyName} 폐업 상조 피해 보상, ${companyName} 가입자 보상, ${companyName} 피해, ${companyName} 보상, ${companyName} 내상조그대로`;

  return {
    props: {
      closedSangjoData,
      pageDescription: description,
      pageOgTitle: title,
      pageOgDescription: description,
      pageKeywords: keywords,
      pageOgImage: "",
    },
  };
};

const ClosedSangjoGuidePage = ({
  closedSangjoData,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { companyname, status } = closedSangjoData;

  return (
    <DefaultPageLayout title={companyname}>
      <Spacing gap={35} />
      <ClosedSangjoMenuTabs />

      <Spacing gap={45} />
      <ParlorClosedGuideInformation companyName={companyname} status={status} />

      <Spacing gap={35} />

      <NextLink
        href={`${GOI_WEB_URL}/guidebook/tip/etc/closed-funeral/`}
        event={{
          domain: "heysangjo",
          path: "closed",
          trigger_and_target: "uv_clsd_guide",
        }}
      >
        <OutlinedButton className="subtitle_18_b" size="medium" fullWidth>
          피해 보상 가이드북
        </OutlinedButton>
      </NextLink>
    </DefaultPageLayout>
  );
};

export default ClosedSangjoGuidePage;
